export type Units = 'Bytes' | 'KB' | 'MB' | 'GB' | 'TB';

export interface FormatChain {
  from(unit: Units): FormatChain;
  to(unit: Units): FormatChain;
  value(): number;
  withUnit(): string;
}

const size: Record<Units, number> = {
  Bytes: 1,
  KB: 1024,
  MB: 1024 ** 2,
  GB: 1024 ** 3,
  TB: 1024 ** 4,
};

export function FormatUnits(value: number): FormatChain {
  let from: Units;
  let to: Units;

  const formatChain: FormatChain = {
    from(unit: Units) {
      from = unit;
      return this;
    },
    to(unit: Units) {
      to = unit;
      return this;
    },
    value(): number {
      return value * (size[from] / size[to]);
    },
    withUnit(): string {
      return `${this.value()} ${to}`;
    },
  };

  return formatChain;
}
